




















import { Component, Prop, Vue } from 'vue-property-decorator';
import DesktopNavTemplate from '@components/header/navigation/desktop/desktop-nav-template.vue';
import { HeaderStyle } from 'types/header';
import { marketingLinks } from '../links';
import NavigationLinkDesktop from '@components/header/navigation/desktop/navigation-link-desktop.vue';
@Component({
	components: {
		DesktopNavTemplate,
		NavigationLinkDesktop
	}
})
export default class DesktopNav extends Vue {
	@Prop()
	private styles!: HeaderStyle;

	marketingLinks = marketingLinks;

	get loginClasses(): string {
		const toReturn = ['button mr-50'];
		if (this.styles.buttonClassLogin) {
			toReturn.push(`${this.styles.buttonClassLogin}`);
		}

		return toReturn.join(' ');
	}

	get getStartedClasses(): string {
		const toReturn = ['button'];

		if (this.styles.buttonClassGetStarted) {
			toReturn.push(`${this.styles.buttonClassGetStarted}`);
		}

		return toReturn.join(' ');
	}
}
